import { NgOptimizedImage } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { Message } from "primeng/message";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { UnsubscribeService } from "./unsubscribe.service";

@Component({
  selector: "new-ui-public-unsubscribe",
  templateUrl: "./new-ui-unsubscribe.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, NewUiButton, Message, NgOptimizedImage, RouterLink],
})
export class NewUiPublicUnsubscribeComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly service = inject(UnsubscribeService);

  showSuccess = false;

  onUnsubscribe(): void {
    const organizationId = this.route.snapshot.paramMap.get("orgId");
    const candidateId = this.route.snapshot.paramMap.get("candidateId");
    this.showSuccess = true;
    this.service.unsubscribeByLink(organizationId, candidateId).subscribe(() => ({}));
  }
}
